import { useEffect, useState } from "react";
import classNames from "classnames";
import { useReactivateAccount } from "../authentication/useReactivateAccount";

const imgs = {
    imgLock: `${process.env.PUBLIC_URL}/imgs/img-lock.png`,
};

const ReactivateAccount = () => {
    const { reactivateAccountForm, setReactivateAccountForm, handleSubmitReactivateAccount } = useReactivateAccount();

    const { usrId, usrEmlAddr } = reactivateAccountForm;

    return (
        <div className="w-full h-auto lg:h-[calc(100vh-250px)] flex items-center relative">
            <div className="find-content-wrap w-full h-auto top-0 left-0 flex items-center justify-center my-[90px] ">
                <div className={classNames("find-content-min w-full md:w-[520px] lg:w-[520px] h-auto relative")}>
                    <img
                        src={imgs["imgLock"]}
                        width={"700px"}
                        height={"auto"}
                        className="grayscale opacity-10 absolute top-[100px] -left-[300px] -z-[1] hidden md:block lg:block"
                    />
                    <div className="find-header bg-primary p-[30px] relative rounded-t-[30px]">
                        <h2 className="text-2xl text-white">Reactivate Dormant Account</h2>
                        <span className="block w-[214px] lg:w-[214px] absolute -top-[70px] -right-[10px] lg:-right-[70px]">
                            <img src={imgs["imgLock"]} width={"100%"} height={"auto"} className="" />
                        </span>
                    </div>
                    <form
                        className="find-body rounded-b-[30px] p-[40px] pt-[70px] bg-card flex flex-col gap-[70px] shadow-lg"
                        onSubmit={handleSubmitReactivateAccount}
                    >
                        <div className="find-body-min flex flex-col gap-[14px]">
                            <p className="flex gap-[5px]">
                                <label htmlFor="usrId" className="block w-[100px] text-sm pt-[8px]">
                                    ID
                                </label>
                                <span className="flex flex-col gap-[4px] w-full">
                                    <input
                                        id="usrId"
                                        type="text"
                                        className="text-sm input bg-transparent h-[36px] w-full"
                                        value={usrId}
                                        onChange={(event) =>
                                            setReactivateAccountForm((prev) => ({ ...prev, usrId: event.target.value }))
                                        }
                                    />
                                </span>
                            </p>
                            <p className="flex gap-[5px]">
                                <label htmlFor="usernumber" className="block w-[100px] text-sm pt-[8px]">
                                    Email Address
                                </label>
                                <span className="flex flex-col gap-[4px] w-full">
                                    <input
                                        id="usrEmlAddr"
                                        type="text"
                                        className="text-sm input bg-transparent h-[36px] w-full"
                                        value={usrEmlAddr}
                                        onChange={(event) =>
                                            setReactivateAccountForm((prev) => ({
                                                ...prev,
                                                usrEmlAddr: event.target.value,
                                            }))
                                        }
                                    />
                                </span>
                            </p>
                        </div>
                        <div className="flex gap-[10px]">
                            <button
                                type="submit"
                                className={classNames(
                                    "w-full rounded-[32px] h-[60px] text-base bg-primary-fill-5 border border-primary text-primary dark:text-white dark:border-white dark:hover:border-primary",
                                    "hover:bg-primary hover:text-white hover:border-primary",
                                )}
                            >
                                Reactivate Dormant Account
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ReactivateAccount;
